export const FavouriteRatingName = {
  Neighborhood: 'neighborhood',
  InteriorCondition: 'interiorCondition',
  InteriorLayout: 'interiorLayout',
  Exterior: 'exterior',
  Commute: 'commute',
  Price: 'price',
  OfferLikelihood: 'offerLikelihood',
};

export default FavouriteRatingName;
